// @flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { DATE_RANGE_FILTERS, TIME_FRAMES } from 'features/command-center/constants';
import type { DatePeriod } from 'types/app';
import { AutocompleteByWeek } from 'UI/components/atoms/AutocompleteByWeek';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';

interface SimplifiedDateRangeProps {
  dateRange: DatePeriod;
  onOptionsLoaded?: (items: object[]) => void;
  onPeriodChange: (period: DatePeriod) => any;
  onTimeFrameChange: (timeFrame: object) => any;
  onWeekChange: (week: string) => any;
  timeFrame: object;
  week: any;
}

export const SimplifiedDateRange = ({
  dateRange,
  onOptionsLoaded,
  onPeriodChange,
  onTimeFrameChange,
  onWeekChange,
  timeFrame,
  week
}: SimplifiedDateRangeProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={3} xs={6}>
        <AutocompleteSelect
          defaultOptions={TIME_FRAMES}
          disableClearable
          name="TIME_FRAMESelector"
          onSelect={onTimeFrameChange}
          placeholder="Time Range"
          selectedValue={timeFrame}
        />
      </Grid>

      <Grid item sm={3} xs={6}>
        {timeFrame === TIME_FRAMES[0] ? (
          <AutocompleteSelect
            defaultOptions={DATE_RANGE_FILTERS}
            disableClearable
            name="dateRangeFilter"
            onSelect={onPeriodChange}
            placeholder="Date Range"
            selectedValue={dateRange}
          />
        ) : (
          <AutocompleteByWeek
            onOptionsLoaded={onOptionsLoaded}
            onSelectWeek={onWeekChange}
            value={week}
          />
        )}
      </Grid>
    </Grid>
  );
};
